import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useModalContext } from "../../../../../../../_metronic/elements/Modal";
import { useIsMobile } from "../../../../../../shared/responsive";

const ModalHeader = ({ isMobile }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={`modal-header prescription-modal__header ${isMobile ? "prescription-modal__header--mobile" : ""}`.trim()}>
        <div className="prescription-modal__title-group">
          <h5 className="modal-title">{t("img_ambient:count.title")}</h5>
          <p className="prescription-modal__description">
            {t("img_ambient:count.description")}
          </p>
        </div>
      </div>
    </>
  );
};

const ModalFooter = ({ isMobile }) => {
  const modal = useModalContext();
  const { t } = useTranslation();

  return (
    <div className={`modal-footer prescription-modal__footer ${isMobile ? "prescription-modal__footer--mobile" : ""}`.trim()}>
      <button type="button" className="btn btn-light prescription-modal__footer-button" onClick={() => modal.hideModal()}>
        {t("img_ambient:count.buttons.cancel")}
      </button>
      <button type="submit" className="btn btn-primary prescription-modal__footer-button">
        {t("img_ambient:count.buttons.accept")}
      </button>
    </div>
  )
}

const ImageAmbientCount = ({ setCountClasses, setNextStep }) => {
  const [cls, setCls] = useState(2);
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const onSubmit = (e) => {
    e.preventDefault();
    setCountClasses(cls)
    setNextStep(true);
  }

  return (
    <>
      <form onSubmit={onSubmit} className='form'>
        <ModalHeader isMobile={isMobile} />
        <div className={`modal-body prescription-modal__body ${isMobile ? "prescription-modal__body--mobile" : ""}`.trim()}>
          <div className="prescription-count-mobile">
            <div className="prescription-count-mobile__grid" role="list" aria-label={t("img_ambient:count.classes_aria")}>
              {[2, 3, 4, 5, 6, 7].map((option) => (
                <button
                  key={option}
                  type="button"
                  onClick={() => setCls(option)}
                  className={`prescription-count-mobile__option ${cls === option ? "active" : ""}`.trim()}
                >
                  <span className="prescription-count-mobile__value">{option}</span>
                  <span className="prescription-count-mobile__label">{t("img_ambient:count.classes_label")}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <ModalFooter isMobile={isMobile} />
      </form>
    </>
  );
};

export default ImageAmbientCount;
